import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="catalog"
export default class extends Controller {
  static targets = [ 'form', 'spinner', 'clear', 'input' ];

  connect() {
    this.timeout = null;

    document.addEventListener( 'turbo:frame-load', () => {
      this.hideSpinner();
      this.updateClearButton();
    } );
  }

  search() {
    clearTimeout( this.timeout );
    this.showSpinner();
    this.hideClearButton();

    this.timeout = setTimeout( () => {
      this.formTarget.requestSubmit();
    }, 200 );
  }

  clearInput() {
    this.inputTarget.value = '';
    this.updateClearButton();
    this.formTarget.requestSubmit();
  }

  updateClearButton() {
    if( !this.hasClearTarget || !this.hasInputTarget ) return;

    const hasValue = this.inputTarget.value.trim().length > 0;
    const spinnerVisible = this.isSpinnerVisible();

    if( hasValue && !spinnerVisible ){
      this.clearTarget.classList.remove( 'd-none' );
    } else {
      this.clearTarget.classList.add( 'd-none' );
    }
  }

  hideClearButton() {
    if( this.hasClearTarget ){
      this.clearTarget.classList.add( 'd-none' );
    }
  }

  isSpinnerVisible() {
    return this.hasSpinnerTarget && !this.spinnerTarget.classList.contains( 'd-none' );
  }

  applySort( event ) {
    event.preventDefault();
    const sortValue = event.currentTarget.dataset.sort;
    const sortInput = this.formTarget.querySelector( '#catalog-sort' );
    if( sortInput ){
      sortInput.value = sortValue;
      this.showSpinner();
      this.hideClearButton();
      this.formTarget.requestSubmit();
    }
  }

  showSpinner() {
    if( this.hasSpinnerTarget ){
      this.spinnerTarget.classList.remove( 'd-none' );
    }
  }

  hideSpinner() {
    if( this.hasSpinnerTarget ){
      this.spinnerTarget.classList.add( 'd-none' );
    }
  }
}
